import { ActivityPopupMeta } from "../types";
import {
  ChequeActivity,
  ChequeActivityAction,
  ChequeActivityData,
} from "./types";
import Container, { EmptyContainer } from "../../meta-container";
import { ChequeConfirmActivityPopup } from "./cheque-confirm-activity";
import { ChequeDeliverActivityPopup } from "./cheque-deliver-activity";
import { ChequeDeleteActivityPopup } from "./cheque-delete-activity";
import { ChequeUpdateActivityPopup } from "./cheque-update-activity";
import { BackContainer } from "../../../types";

const ChequeActivityPopupRenderer = <T extends {}>(
  props: ActivityPopupMeta<T>
) => {
  const activity = props.data as ChequeActivity;
  return (
    <Container<ChequeActivityAction, BackContainer<ChequeActivityData, T>>
      data={{ data: activity.data, back: props.back }}
      type={activity.action}
      match={{
        [ChequeActivityAction.None]: EmptyContainer,
        [ChequeActivityAction.Confirm]: ChequeConfirmActivityPopup,
        [ChequeActivityAction.Delete]: ChequeDeleteActivityPopup,
        [ChequeActivityAction.Deliver]: ChequeDeliverActivityPopup,
        [ChequeActivityAction.Update]: ChequeUpdateActivityPopup,
      }}
    />
  );
};

export default ChequeActivityPopupRenderer;
